import OutOfBandAuthenticationCode from '@polleverywhere/core/lib/models/out_of_band_authentication_code'
import env from '@polleverywhere/core/lib/env'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'
import URI from 'urijs'
import openWindow from './open_window'

let code

export function outOfBandAuth ({ signupEnabled = true } = {}) {
  return new Promise((resolve, reject) => {
    code = generateCode(resolve, reject)
    code.save().then(() => {
      const { role } = store.getState()[appSlice.name]

      if (role === 'webex') {
        const outOfBandUrl = URI(env.get('api_url'))
          .path(`auth/out_of_band_authentication_codes/${code.get('code')}`)

        openWindow(outOfBandUrl, { features: ['resizable', 'scrollbars', 'status'] })
      } else {
        const authUrl = URI({
          protocol: 'https',
          hostname: env.get('auth_fqdn'),
          path: `code/${code.get('code')}`,
          query: `forceLogout=true${!signupEnabled ? '&disabled=signups' : ''}`
        })
        if (window.Office?.UI?.openBrowserWindow) {
          window.Office.UI.openBrowserWindow(authUrl)
        } else {
          openWindow(authUrl, { features: ['resizable', 'scrollbars', 'status'] })
        }
      }

      code.startChecking()
    })
  })
}

export function outOfBandOnboarding (source = 'unknown') {
  return new Promise((resolve, reject) => {
    code = generateCode(resolve, reject)
    code.save().then(() => {
      const onboardingContinuedUrl = URI(env.get('api_url'))
        .path('account/surveys/use_case')

      const outOfBandUrl = URI(env.get('api_url'))
        .path(`auth/out_of_band_authentication_codes/${code.get('code')}`)
        .query(`redirect=${encodeURIComponent(onboardingContinuedUrl)}`)

      const signupUrl = URI(env.get('api_url'))
        .path('signup')
        .query(`user[role]=presenter&usrc=${source}&redirect=${encodeURIComponent(outOfBandUrl)}`)

      openWindow(signupUrl, { features: ['resizable', 'scrollbars', 'status'] })

      code.startChecking()
    })
  })
}

export function outOfBandStop () {
  code?.stopChecking()
}

function generateCode (resolve, reject) {
  const code = new OutOfBandAuthenticationCode()

  code.on('completed', resolve)
  code.on('failed', reject)

  return code
}
